import React from 'react';

import { Box } from '@chakra-ui/react';
import SelectGroupLabel from './SelectGroupLabel';

interface SelectGroupProps {
  dark: boolean;
  label?: string;
}

const SelectGroup: React.FC<SelectGroupProps> = ({ children, label, dark }) => (
  <Box as="ul" listStyleType="none" outline="none" w="100%" borderRadius="md">
    {label && <SelectGroupLabel dark={dark}>{label}</SelectGroupLabel>}
    {children}
  </Box>
);

export default SelectGroup;
